
import { $t } from './services/i18n.js';

export const AppMenus = {
    
	navbarTopRight: [],
	navbarTopLeft: [],
	navbarSideLeft: [

  {
    "to": "/invoices",
    "label": $t('invoices'),
    "icon": "pi pi-dollar",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/suppliers",
    "label": $t('suppliers'),
    "icon": "pi pi-building",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/repse",
    "label": $t('repseMenu'),
    "icon": "pi pi-calendar-times",
    "iconcolor": "",
    "target": "",
    
  },
  
  {
    "to": "/efos",
    "label": $t('efosMenu'),
    "icon": "pi pi-exclamation-circle",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "",
    "label": $t('administration'),
    "icon": "pi pi-cog",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/users",
        "label": $t('users'),
        "icon": "pi pi-user",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/permissions",
        "label": $t('permissions'),
        "icon": "pi pi-ban",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/roles",
        "label": $t('roles'),
        "icon": "pi pi-tags",
        "iconcolor": "",
        "target": "",
        
      }
      
    ]
  }
],

    exportFormats: {
        print: {
			label: 'Print',
            icon: 'pi pi-print',
            type: 'print',
            ext: 'print',
        },
        pdf: {
			label: 'Pdf',
			
            icon: 'pi pi-file-pdf',
            type: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
            icon: 'pi pi-file-excel',
            type: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
            icon: 'pi pi-table',
            type: 'csv',
            ext: 'csv',
        },
    },
    locales: {
  //"fr": "French",
  //"ru": "Russian",
  //"zh-CN": "Chinese",
  "en-US": "English",
  //"it": "Italian",
  //"hi": "Hindi",
  //"pt": "Portuguese",
  //"de": "German",
  "es": "Spanish",
  //"ar": "Arabic"
}
}